import { Flex, Icon, ProductColor } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-box
import { Box } from '@aloft/toolkit-sui/chakra';

import { TwoLineCell } from '../../../Grid/TwoLineCell.tsx';
import { CompSelectionProperty } from '../../types.ts';

const getRentalPinColor = (property: CompSelectionProperty): ProductColor => {
  const s = property.mlsStatus?.toLowerCase() ?? '';
  if (s === 'closed' || s.includes('rent') || s.includes('leased') || s.includes('sold')) {
    return 'pinRented';
  }
  if (s === 'active' || s.includes('active')) {
    return 'pinActive';
  }
  if (s === 'pending' || s.includes('contract')) {
    return 'pinPending';
  }
  return 'pinOther';
};

export const RentalStatusColumn = (property: CompSelectionProperty, index: number) => {
  const { id, mlsStatus } = property;

  const showIndex = id !== 'subject';
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex height="100%" alignItems="center" justifyContent="center" paddingRight={2}>
        {id === 'subject' ? (
          <Icon icon="home-heart-filled" size="lg" color="pinSubject" />
        ) : (
          <Box position="relative">
            <Icon icon="map-pin-filled" size="lg" color={getRentalPinColor(property)} />
            {showIndex && (
              <Box
                position="absolute"
                top="40%"
                left="50%"
                transform="translate(-50%, -50%)"
                fontSize="xs"
                fontWeight="bold"
                color="white"
                lineHeight="1"
                pointerEvents="none"
              >
                {index}
              </Box>
            )}
          </Box>
        )}
      </Flex>
      <Box paddingRight={2} flexGrow={1}>
        <TwoLineCell line1={mlsStatus || ''} line2="" />
      </Box>
    </Flex>
  );
};
